import { IkeToken } from '@ikegps/core-api';
import type { CollectionModel } from '@ikegps/core-shared';
import { addStyles } from '../../../components/theme';
import { UserName } from '../../../components/user/username';
import { T, Translate } from '../../../i18n/index';
import type { MithrilVNode } from '../../../mithril';
import { m } from '../../../mithril';
import { Services } from '../../../services';
import { AppStore } from '../../../store/index';
import { CSS, Style } from './collection.meta.info.style';

addStyles(Style);

export const CollectionMetaInfo = {
	view(collection: CollectionModel): MithrilVNode {
		const summary = AppStore.CollectionSummary.get(collection.revision);
		var updatedById = collection.updatedBy;
		if (summary != null) {
			updatedById = summary.updatedBy[0];
		}

		const collectedBy = UserName.view(collection.collectedBy);
		const updatedBy = UserName.view(updatedById);

		let displayedFormName = collection.schema.displayName;
		if ((collection.schema.displayVersion ?? 0) > 0) {
			displayedFormName = displayedFormName + ` (V${collection.schema.displayVersion})`;
		}
		return m('div', { className: CSS.container }, [
			CollectionMetaInfo.viewItem(T.COLLECTION_COLLECTED_AT, Services.DateTime.formatDateTime(collection.recordedAt)),
			collectedBy != null ? CollectionMetaInfo.viewItem(T.COLLECTION_COLLECTED_BY, collectedBy) : null,
			CollectionMetaInfo.viewItem(T.COLLECTION_UPDATED_AT, Services.DateTime.formatDateTime(collection.updatedAt)),
			updatedBy != null ? CollectionMetaInfo.viewItem(T.COLLECTION_UPDATED_BY, updatedBy) : null,
			this.viewAssigned(collection),
			CollectionMetaInfo.viewItem(T.COLLECTION_FORM_NAME, displayedFormName),
		]);
	},

	viewAssigned(collection: CollectionModel): string | MithrilVNode {
		if (
			!(
				Services.Token.has(IkeToken.FEATURE_COLLECTION_ASSIGN) || Services.Token.has(IkeToken.FEATURE_GROUP_IKE_ANALYZE)
			)
		) {
			return null;
		}

		if (collection.assignedTo != null) {
			const assignedTo = UserName.view(collection.assignedTo);
			return CollectionMetaInfo.viewItem(T.COLLECTION_ASSIGNED_TO, assignedTo);
		}

		return CollectionMetaInfo.viewItem(T.COLLECTION_ASSIGNED_TO, Translate(T.COLLECTION_UNASSIGNED));
	},

	viewItem(name: T, value: string | MithrilVNode): MithrilVNode {
		return m('div', { className: CSS.item }, [
			m('span', { className: CSS.name }, Translate(name)),
			m('span', { className: CSS.value }, value),
		]);
	},
};
